<template>
  <div class="relative">
    <ShowSignNotifiedModal />
    <div v-if="!loading" class="w-full">
      <div class="lg:hidden">
        <PTabs
          v-model="tab"
          customBtnStyle
          :class="`[&_.p-tab]:p-0! [&_.p-tabs]:border-0 [&_.p-tag-button]:border-transparent [&_.p-tag-button-active]:bg-white [&_.p-tag-button-active]:border-grey-925 ${pTabColors.bg} ${pTabColors.borderTop}`"
        >
          <PTab
            data-sentry-id="HomeTabCurrent"
            name="current"
            :label="`En cours à mon niveau : ${store.home.current.total}`"
          >
            <Current />
          </PTab>
          <PTab name="todo" :label="`En amont : ${store.home.todo.total}`" data-sentry-id="HomeTabCurrent">
            <Todo />
          </PTab>
          <PTab name="done" :label="`En aval : ${store.home.done.total}`" data-sentry-id="HomeTabCurrent">
            <Done />
          </PTab>
        </PTabs>
      </div>
      <div class="hidden lg:flex flex-row gap-1 md:gap-2 lg:gap-4 w-full h-full">
        <Todo />
        <Current />
        <Done />
      </div>
    </div>
    <div v-else>
      <Loader class="absolute" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { PTab, PTabs } from "@pasta/box-v2";
import { useLetterFileStore } from "../../stores/letter-file.store";
import Loader from "../../components/Loader.vue";
import { useLoadingStore } from "../../stores/loading.store";
import Todo from "./Todo.vue";
import Current from "./Current.vue";
import Done from "./Done.vue";
import { useLetterFileColor } from "../../composable/useLetterFileColor";
import ShowSignNotifiedModal from "../../components/ShowSignNotifiedModal.vue";

const store = useLetterFileStore();

const loadingStore = useLoadingStore();
const loading = computed(() => loadingStore.isLoading("set-lf"));

const { pTabColors } = useLetterFileColor();
const tab = ref<string>("current");

async function fetchHome() {
  loadingStore.setLoading("set-lf", true);
  await store.getHome();
  loadingStore.setLoading("set-lf", false);
}

onMounted(fetchHome);
</script>
